import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css';
import 'remixicon/fonts/remixicon.css';
import App from './App.jsx';
import { UIProvider } from './context/UIContext';

// Global runtime error overlay to surface issues in the browser during development
function showRuntimeError(message, stack) {
    const existing = document.getElementById('runtime-error-overlay');
    if (existing) existing.remove();
    const el = document.createElement('div');
    el.id = 'runtime-error-overlay';
    Object.assign(el.style, {
        position: 'fixed',
        inset: '0',
        background: 'rgba(0,0,0,0.85)',
        color: '#fff',
        padding: '24px',
        zIndex: '999999',
        fontFamily: 'monospace',
        overflow: 'auto'
    });
    el.innerHTML = `<h2 style="color:#ff6b6b;margin-top:0">Runtime Error</h2><pre style="white-space:pre-wrap">${message}\n${stack || ''}</pre>`;
    document.body.appendChild(el);
}

window.addEventListener('error', (ev) => {
    console.error('Runtime error captured', ev.error || ev.message, ev.error && ev.error.stack);
    showRuntimeError(String(ev.error?.message || ev.message), String(ev.error?.stack || ''));
});

window.addEventListener('unhandledrejection', (ev) => {
    console.error('Unhandled promise rejection', ev.reason);
    showRuntimeError(String(ev.reason?.message || ev.reason), String(ev.reason?.stack || ''));
});

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <UIProvider>
            <App />
        </UIProvider>
    </StrictMode>,
);
